import React, { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { useNavigate, useLocation } from "react-router-dom";

import { serverResponse } from "../../util/fakeServer";
import { setIndexCarousel, isFromInput } from "../../redux/carousel/action";
import { toggleJWTModal } from "../../redux/authJWT/action";
import { openInteractivityModal } from "../../redux/modal/action";
import {
  // defaultLanguage,
  getAnalyticsDevice,
  getAnalyticsUniqueId,
  getCustomActions,
  hasProducts,
  sendVisit,
  defaultLanguage,
} from "../../helper/utility";
import { language } from "../../languageProvider/language/language";
import { visit } from "../../services/analytics.services";
import {
  isMobileOnly,
  isTablet,
  isIPad13,
  isBrowser as isDesktop,
} from "react-device-detect";
import ManagerFactory from "../../managers/ManagerFactory";
import "./header.css";
import { CartIcon } from "../../assets/icons";
import GroceryList from "../floatingGroceryList/GroceryList";
import { interattivoIcon } from "../../helper/constant";
// import userImage from "../../assets/images/user-img.png";
import UserAvatar from "../UserAvatar/UserAvatar";
import InpublishLogo from "../../assets/icons/inpublish.logo";
import CategoryMenu from "../common/CategoryIndex/CategoryMenu";
import SearchBottomSheet from "../Categories/mobile/SearchBottomSheet";

const tabRoutes = ["/leaflet", "/categories"];

const Header = (props) => {
  const manager = ManagerFactory.getManager();

  const navigate = useNavigate();
  const location = useLocation();

  const isCategoriesPage = location.pathname === "/categories";

  const [activeTab, setActiveTab] = useState(
    tabRoutes.includes(location.pathname) ? location.pathname : null
  );

  const [popoverOpen, setPopoverOpen] = useState(false);
  const toggle = () => {
    setPopoverOpen(!popoverOpen);
    // if (popoverOpen) {
    //   ReactGA.pageview(
    //     `/${serverResponse.config.client_id}-${serverResponse.leaflet.id}/lista-spesa`
    //   );
    // }
  };

  // ---- Mobile search bottom-sheet (Step 3 restyling) ----------------------
  const [searchSheetOpen, setSearchSheetOpen] = useState(false);
  const [searchSheetQuery, setSearchSheetQuery] = useState("");

  const searchProducts = useMemo(() => {
    try {
      const inter = (serverResponse && serverResponse.interactivities) || {};
      return Object.values(inter).filter(
        (el) => el && el.type === "product" && el.description
      );
    } catch (_e) {
      return [];
    }
    // serverResponse is static at runtime — no deps required.
  }, []);

  const searchCategories = useMemo(() => {
    try {
      const cats =
        (serverResponse &&
          serverResponse.leaflet &&
          serverResponse.leaflet.categories) ||
        [];
      return cats
        .map((c) => ({
          id: c.id != null ? c.id : c.category_name,
          name: c.category_name,
          logo: c.category_logo || null,
        }))
        .filter((c) => c.name)
        .slice(0, 6);
    } catch (_e) {
      return [];
    }
  }, []);

  const showSearchTrigger = hasProducts();

  const openSearchSheet = () => setSearchSheetOpen(true);
  const closeSearchSheet = () => setSearchSheetOpen(false);

  const handleSearchProductSelect = (productId) => {
    try {
      const info = getCustomActions().getInteractivity(productId);
      if (info) {
        props.openInteractivityModal({ info, type: "plus" }, productId);
      }
    } catch (_e) {
      /* no-op */
    }
  };

  const handleSearchSeeAll = (q) => {
    setSearchSheetQuery(q || "");
    const qs = q ? `?q=${encodeURIComponent(q)}` : "";
    navigate(`/categories${qs}`);
  };

  const handleSearchCategorySelect = (name) => {
    setSearchSheetQuery("");
    const qs = name ? `?cat=${encodeURIComponent(name)}` : "";
    navigate(`/categories${qs}`);
  };

  const searchTriggerAriaLabel =
    (language[defaultLanguage] &&
      language[defaultLanguage].cerca_prodotti) ||
    "Search products";

  useEffect(() => {
    setActiveTab(
      tabRoutes.includes(location.pathname) ? location.pathname : null
    );
  }, [location.pathname]);

  const handleTabClick = (path) => {
    setActiveTab(path);
    navigate(path);
  };

  useEffect(() => {
    if (
      serverResponse.config.ga_active &&
      sendVisit() &&
      manager.sendAnalitics()
    ) {
      visit({
        id_cliente: serverResponse.config.client_id,
        id_insegna: serverResponse.config.signboard_id,
        id_utente: serverResponse.config.release_id,
        id_volantino: serverResponse.leaflet.id,
        device: getAnalyticsDevice(
          isMobileOnly,
          isTablet || isIPad13,
          isDesktop && !isIPad13
        ),
        unique_id: getAnalyticsUniqueId(),
      });
    }
  }, [manager]);

  // const handleOnClick = useCallback(
  //   (value) => navigate({ pathname: value, from: true }),
  //   [navigate]
  // );

  // const [popoverOpen, setPopoverOpen] = useState(false);
  // const toggle = () => {
  //   setPopoverOpen(!popoverOpen);
  //   if (popoverOpen) {
  //     ReactGA.pageview(
  //       `/${serverResponse.config.client_id}-${serverResponse.leaflet.id}/lista-spesa`
  //     );
  //   }
  // };

  // const appLogo = manager.getAppLogo();
  // const appLogoSize = manager.getAppLogoSize();
  // const headerLink = manager.getLogoHeaderLink();
  // const logoMaxSize = manager.getLogoClientMaxSize();
  return (
    <div
      className={`mobile-header d-block d-sm-none ${
        isCategoriesPage && "shadowNone"
      }`}
    >
      <div className="mobile-top-bar">
        <div className="left-content">
          {/* {serverResponse.config.allow_login && ( */}
          <div className="icon">
            {serverResponse.config.type === "inpublish" ? (
              <InpublishLogo />
            ) : (
              <img
                className="img-fluid"
                src={interattivoIcon}
                style={{ width: "38px", alignSelf: "center" }}
                alt="logo interattivo"
              />
            )}
          </div>
          {/* )} */}
        </div>

        <div className="middle-content">
          <div className="logo">
            <img
              // style={{ width: "90px" }}
              src={serverResponse.config.logo_full}
              alt=""
            />
          </div>
        </div>
        <div className="right-content">
          {showSearchTrigger && (
            <button
              type="button"
              className="pf-search-trigger"
              aria-label={searchTriggerAriaLabel}
              onClick={openSearchSheet}
            >
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.75"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
                focusable="false"
              >
                <circle cx="11" cy="11" r="7" />
                <line x1="20" y1="20" x2="16.65" y2="16.65" />
              </svg>
            </button>
          )}
          {props.authJWT.user ? (
            <div className="d-flex user-profile-mobile">
              {/* <img src={userImage} alt="" /> */}
              <span className="user-name">
                <UserAvatar />
              </span>
            </div>
          ) : serverResponse.config.allow_login ? (
            <p
              style={{
                color: "var(--primary-color)",
                fontSize: "14px",
                fontWeight: "bold",
                textAlign: "center",
                cursor: "pointer",
              }}
              onClick={() => navigate("/login")}
              className="btn-login"
            >
              Accedi
            </p>
          ) : (
            !serverResponse.config.hide_grocery_list && hasProducts() && (
              <div className="cart-icon text-right" onClick={toggle}>
                {manager.getCartIcon({id:"mobile-grocery"})}
                {props.groceryList.length > 0 && (
                  <span className="notificatopn-badge">
                    {props.groceryList.length}
                  </span>
                )}
                <GroceryList
                  isOpen={popoverOpen}
                  toggle={toggle}
                  placement={"bottom"}
                  target="mobile-grocery"
                  isMobile={true}
                />
              </div>
            )
          )}
        </div>
      </div>
      {serverResponse.config.sidebar.includes("products") && hasProducts() && (
        <div className="mobile-header-bottom-content">
          <ul className="filter-wrap">
            <li
              className={activeTab === "/leaflet" ? "active" : ""}
              onClick={() => handleTabClick("/leaflet")}
            >
              sfoglia
            </li>
            <li
              className={activeTab === "/categories" ? "active" : ""}
              onClick={() => handleTabClick("/categories")}
            >
              prodotti
            </li>
          </ul>
        </div>
      )}
      {manager.showCategoryIndex() && <CategoryMenu target="mobile" />}

      {showSearchTrigger && (
        <SearchBottomSheet
          open={searchSheetOpen}
          onClose={closeSearchSheet}
          onProductSelect={handleSearchProductSelect}
          onSeeAllResults={handleSearchSeeAll}
          onCategorySelect={handleSearchCategorySelect}
          products={searchProducts}
          categories={searchCategories}
          currentPathname={location.pathname}
          initialQuery={searchSheetQuery}
        />
      )}
    </div>
    // <HeaderWrapper {...props}>
    // <div>
    //   <div className="container-fluid" style={{ height: H_COMPONENTS.header }}>
    //     <div className="row h-100">
    //       <div className="col-12 d-flex align-items-center justify-content-between p-md-1 p-2 d-lg-none h-100">
    //         <>
    //           {serverResponse.config.logo_full && (
    //             <img
    //               className="h-100"
    //               id="logo_client"
    //               src={serverResponse.config.logo_full}
    //               alt="react-logo"
    //               style={{ maxWidth: "150px", objectFit: "contain" }}
    //             />
    //           )}
    //           <a
    //             href={headerLink}
    //             target="_blank"
    //             rel="noopener noreferrer"
    //             style={styles.link_decoration}
    //           >
    //             {appLogo !== '' && <img
    //               className="h-100"
    //               id="logo_header"
    //               src={appLogo}
    //               alt="react-logo"
    //               style={styles.logo_header}
    //             />}
    //             <p style={styles.p_style}>v{process.env.REACT_APP_VERSION}</p>
    //           </a>
    //         </>

    //         {serverResponse.config.no_link_to_site && (
    //           <img src={iconAppNameNegative} alt="react-logo" />
    //         )}
    //       </div>
    //       <div className="col-6 d-lg-none d-flex justify-content-center align-items-center"></div>

    //       <div className="col-12 d-none d-lg-flex justify-content-center">
    //         <div className="container-fluid p-0 custom_header_container_fluid">
    //           <div className="row h-100">
    //             <div className="col-lg-4 d-flex align-items-center">
    //               <img src={appLogo} style={{ width: appLogoSize }} alt="" />
    //             </div>
    //             <div className="col-lg-8 d-flex justify-content-end align-items-center">
    //               {serverResponse.config.allow_login && (
    //                 <>
    //                   {props.authJWT.loadingProfile ? (
    //                     <div
    //                       className="spinner-grow"
    //                       style={styles.spinner_grow}
    //                       role="status"
    //                     />
    //                   ) : props.authJWT.isAuthenticated ? (
    //                     <UserAvatar />
    //                   ) : (
    //                     <p
    //                       onClick={() => {
    //                         //props.toggleJWTModal();
    //                         navigate("/login");
    //                       }}
    //                       className="login_button"
    //                     >
    //                       {language[defaultLanguage].login}
    //                     </p>
    //                   )}
    //                 </>
    //               )}
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    //   {!serverResponse.config.hide_grocery_list && (
    //     <GroceryList
    //       isOpen={popoverOpen}
    //       toggle={toggle}
    //       placement={"bottom"}
    //       target="mobile-grocery"
    //       isMobile={true}
    //     />
    //   )}
    // </HeaderWrapper>
    // </div>
  );
};
const mapStateToProps = (state) => {
  return {
    groceryList: state.groceryList.list,
    carouselIndex: state.carousel,
    authJWT: state.authJWT,
  };
};
export default compose(
  connect(mapStateToProps, {
    setIndexCarousel,
    isFromInput,
    toggleJWTModal,
    openInteractivityModal,
  })
)(Header);
